export default process.env.REACT_APP_MINT_PASS_ADDRESS ||
  '0xCaA7552A01e0D2848D9800C933221D501F84e0F2';
